import React from 'react';
import {
  FacebookShareButton,
  TwitterShareButton,
  TelegramShareButton,
  WhatsappShareButton,
  EmailShareButton,
  


} from 'react-share';
import {FaFacebookF,FaXTwitter ,FaTelegramPlane ,FaWhatsapp,MdOutlineMailOutline} from "../icons"
import { renderText } from '../hooks/TextVeiw';
import { useTranslation } from 'react-i18next';

const ShareArticle = ({ url, title, description }) => {
    const desc = renderText(description)
    const {t}=useTranslation()
  return (
    <div className="share-container flex flex-row w-full mt-10 gap-2 items-start justify-center ">
      <h3 className='text-sm font-kufi text-gray-600 dark:text-gray-300 mb-2'>{t("Share this Article")}  </h3>
      
      <div className=" gap-2 flex flex-row ">
        <FacebookShareButton 
          url={url}
          quote={title}
          hashtag="#مقال"
          className=""
      
          
        >
          <FaFacebookF size={20} className='text-light-text dark:text-dark-text hover:text-light-blue' />
        </FacebookShareButton>
        
        <TwitterShareButton
          url={url}
          title={title}
          via="yourTwitterHandle"
          hashtags={["مقال", ""]}
          className="share-button"
        >
          <FaXTwitter size={20} className='text-light-text dark:text-dark-text hover:text-light-blue'  />
        </TwitterShareButton>
        
        <TelegramShareButton
          url={url}
          title={title}
          className="share-button"
        >
          <FaTelegramPlane size={20} className='text-light-text dark:text-dark-text hover:text-light-blue'  />
        </TelegramShareButton>
        
        <WhatsappShareButton
          url={url}
          title={title}
          separator=" :: "
          className="share-button"
        >
          <FaWhatsapp size={20} className='text-light-text dark:text-dark-text hover:text-light-blue'   />
        </WhatsappShareButton>
        
        <EmailShareButton
          url={url}
          subject={title}
          body={desc}
          className="share-button"
        >
          <MdOutlineMailOutline size={20} className='text-light-text dark:text-dark-text hover:text-light-blue'  />
        </EmailShareButton>
      </div>
    </div>
  );
};

export default ShareArticle;